import type { EditorSDK } from '@wix/platform-editor-sdk';

import { APP_TOKEN } from '../constants';

export const getApplicationPopupPages = (editorSDK: EditorSDK) => {
  return editorSDK.document.pages.popupPages.getApplicationPopups(APP_TOKEN);
};
